$(function() {
  if ($('body').hasClass('information-page')) {
    $('.js-infopage-testimonials-carousel').slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: '80px',
      infinite: true,
      arrows: true,
      mobileFirst: true,
      prevArrow:
        '<button class="infopage-testimonials-carousel__previous-arrow" aria-label="Previous"><i class="icon icon--arrow-simple icon--rotate-left icon--large"></i></button>',
      nextArrow:
        '<button class="infopage-testimonials-carousel__next-arrow" aria-label="Next"><i class="icon icon--arrow-simple icon--large"></i></button>',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            centerPadding: '10px'
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1
          }
        },
        {
          breakpoint: 1024,
          settings: 'unslick'
        }
      ]
    });
  }
});

$('.js-infopage-testimonials-carousel').on('init', function() {
  $('[data-tooltip]').foundation();
});
